import { USER_TYPE } from '@/shared/config/user-type';

/**
 * Calculates derived user information based on the user object.
 * @param {object} user - The user object.
 * @param {number|null} user.parentId - The ID of the parent user. Null if the user is a main partner.
 * @param {number} user.type_id - The type ID of the user (e.g., USER_TYPE.BANK).
 * @returns {{ isMainPartner: boolean, isBankPartner: boolean }} An object containing user-related flags:
 * - `isMainPartner`: True if the user is a main partner.
 * - `isBankPartner`: True if the user is a bank partner.
 */
export function calculateUserInfo(user) {
  return {
    isMainPartner: user?.parentId === null,
    isAgent: !user?.organizationId,
    isBankPartner: user?.type_id === USER_TYPE.BANK,
    isHeadOrganization: user?.organizationType === 'head',
    isActivePenalty: user?.isActivePenalty,
    isNeedOnboarding: user?.isNeedOnboarding,
    isUnderReview: user?.isUnderReview,
    onboardingInfo: user?.onboardingInfo,

    organizationId: user?.organizationId || null,
  };
}
